export default __webpack_public_path__ + "static/media/Settings.ae8a5b2c.svg";